/**
 * The Admin support desk (W5-SUPPORT-DESK, D384, ADR-0054) — pure rules the Cases queue and the Ticket detail render.
 * The server authorizes and decides everything; these only say what to show:
 *
 * - `priorityTone` reads the server's priority vocabulary (`HIGH`, `URGENT`). Before D384 the queue compared `'high'` with
 *   the server's `'HIGH'`, so no ticket was ever red.
 * - `ticketAge` and `assigneeOf` are the queue's "how old" and "who works it" columns.
 * - `deskPrimaryAction` names the ONE primary action the ticket detail shows in each state (one primary per screen).
 * - `revealOptions` lists the parties a reveal may target, only when the server says the reveal is allowed.
 */
import { type SupportTicketDetail, type SupportParty } from '@vello/api-client';

export {
  type DeskTone,
  type DeskPrimaryAction,
  type TicketReopenReason,
  TICKET_REOPEN_REASONS,
  priorityTone,
  ticketStatusTone,
  ticketAge,
  assigneeOf,
  deskPrimaryAction,
  canWork,
  canReopen,
  shortTicketId,
  ticketReference,
  looksLikeProtocol,
} from '@vello/support-desk-ux';

/** The parties a reveal may target — none unless the server says the reveal is allowed on this ticket. */
export function revealOptions(detail: Pick<SupportTicketDetail, 'contactReveal'>): readonly SupportParty[] {
  return detail.contactReveal.allowed ? detail.contactReveal.parties : [];
}

/** How a subject is looked up, by kind — the hint the open-for-caller form shows. */
export function subjectQueryHintId(kind: string): string {
  if (kind === 'RIDE') return 'desk.subject.hint.ride';
  if (kind === 'DESK_ORDER') return 'desk.subject.hint.desk';
  return 'desk.subject.hint.person';
}
